import React from 'react';
import ReactApexChart from 'react-apexcharts';

import { useTheme } from 'styled-components';

import { Container, Label } from './styles';

interface IDistributedColumnsPrices2Props {
  label?: string;
  grossDiscountPrice: number;
  totalTaxDeductionsPrice: number;
  netDiscountPrice: number;
}

const DistributedColumnsPrices2: React.FC<IDistributedColumnsPrices2Props> = ({
  label,
  grossDiscountPrice,
  totalTaxDeductionsPrice,
  netDiscountPrice,
}: IDistributedColumnsPrices2Props) => {
  const { colors } = useTheme();

  const optionColors = [
    colors.chartGrossDiscountPrice,
    colors.chartTotalTaxDeductionsPrice,
    colors.chartNetDiscountPrice,
  ];

  const series = [
    {
      name: '',
      data: [grossDiscountPrice, totalTaxDeductionsPrice, netDiscountPrice],
    },
  ];

  const options = {
    chart: {
      offsetX: 0,
      offsetY: 0,
      redrawOnWindowResize: true,
      toolbar: {
        show: false,
      },
    },
    colors: optionColors,
    plotOptions: {
      bar: {
        columnWidth: '50%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        'Valor Solicitado',
        'Valor Abatimentos Fiscais',
        'Valor Total',
      ],
      labels: {
        style: {
          colors: optionColors,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        formatter: (value: number) => {
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    },
  };

  return (
    <Container>
      {label && <Label>{label}</Label>}

      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </Container>
  );
};

export default DistributedColumnsPrices2;
